import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { BatchStudent } from "@shared-kernel/application/ports/educational-advisor/educational-advisor-repository";
import type { Nullable } from "@shared-kernel/core/types/nullable";

export const retrieveEducationalAdvisorStudentByEmail = createAsyncThunk<Nullable<BatchStudent>, string, { extra: Partial<Dependencies> }>(
  "educationalAdvisor/retrieveEducationalAdvisorStudentByEmail",
  async (email: string, { extra: { educationalAdvisorRepository } }) => {
    return educationalAdvisorRepository!.getStudentByEmail(email);
  },
);

export const resetRetrieveEducationalAdvisorStudentByEmail = createAction(
  "educationalAdvisor/resetRetrieveEducationalAdvisorStudentByEmail",
);
